import { EventTypes } from '../lib/constants';
import withPusher from './withPusher';
import config from '@/config';

export default {
	mixins: [withPusher],

	computed: {
		donationDownloadChannelName() {
			return `account.${config.hpStoreAccountID}.donations.download.result`;
		}
	},

	mounted() {
		if (!config.hpStoreAccountID) return;
		this.initializePusherSubscribers();
	},

	beforeDestroy() {
		if (!this.pusherClient) return;
		this.pusherClient.unsubscribe(this.donationDownloadChannelName);
	},

	methods: {
		donationDownloadCompleteHandler(message) {
			const { url } = _.get(message, 'data', {});
			if (!url) return;

			this.isDownloadingDonations = false;

			this.$notify({
				type: 'success',
				title: this.$t('Download ready'),
				text: this.$t('Your donation export is ready. Starting download...')
			});

			// Trigger download
			const link = document.createElement('a');
			link.href = url;
			link.download = '';
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},

		initializePusherSubscribers() {
			try {
				const existingChannels = this.pusherClient.getChannels();
				const existingDonationDownloadChannel = _.find(existingChannels, ['name', this.donationDownloadChannelName]);
				if (existingDonationDownloadChannel) return;

				this.pusherClient.subscribe(
					this.donationDownloadChannelName,
					EventTypes.DonationsDownloadComplete,
					this.donationDownloadCompleteHandler
				);
			} catch (error) {
				this.$notify({
					type: 'error',
					title: this.$t('Error'),
					text: this.$t('Error while initializing donation download subscriber')
				});
			}
		}
	}
};
